import { fork } from "typed-redux-saga"
import { calendarsRootSaga as baseCalendarRootSaga } from "@common/common/frontend/features/calendar/sagas"

export function* calendarRootSaga() {
  yield* fork(baseCalendarRootSaga)
}
